import { useState } from 'react';
import { DeleteOutline } from '@mui/icons-material';
import { ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttButton } from './SttButton';
import ModalConfirmation from '../../layout/ModalConfirmation';
import { usePermission } from '../../lib/usePermission';
import { PermissionRequirement } from '../../lib/permissions';

type SttButtonDeleteProps = {
    onClick?: () => void | Promise<void>;
    caption?: string;
    confirmation?: boolean;
    /** Permiso v8 que hace falta para ver el botón. Sin él, se ve siempre. */
    permission?: PermissionRequirement;
} & Omit<ButtonProps, 'onClick'>;

/**
 * Delete button
 */
export function SttButtonDelete({
    onClick,
    permission,
    caption,
    confirmation = false,
    ...rest
}: SttButtonDeleteProps) {
    const { t } = useTranslation();
    const [confirmationDialog, setConfirmationDialog] = useState({
        show: false,
    });
    const { can } = usePermission();

    if (permission && !can(permission)) return null;

    return (
        <>
            <SttButton
                onClick={
                    confirmation
                        ? () => setConfirmationDialog({ show: true })
                        : onClick
                }
                caption={caption || t('Delete')}
                color="error"
                variant="contained"
                className="button-delete"
                icon={<DeleteOutline />}
                {...rest}
            />

            <ModalConfirmation
                show={confirmationDialog.show}
                onClose={() => setConfirmationDialog({ show: false })}
                onAccept={() => {
                    onClick?.();
                    setConfirmationDialog({ show: false });
                }}
            />
        </>
    );
}
